import React from 'react';
import classnames from 'classnames';
import { Button, Glyphicon } from 'react-bootstrap';

import Api from '../../../api/api';

class Exercise extends React.Component {
  state = {
    showCategoryText: false,
    showExerciseExtraOptions: false,
  };

  handleClick = () => {
    this.setState({ showExerciseExtraOptions: false });

    this.props.setExerciseNumberToBeChanged(this.props.exercise.number);

    this.props.toggleModal();
  };

  openPDF = () =>
    Api.users.downloadExercise(this.props.exercise.number).then(exerciseViewedStatusUpdated => {
      if (exerciseViewedStatusUpdated) {
        window.open(this.props.exercise.pdf_original_url);
      }
    });

  render() {
    const { title, number, pdf_original_url, category, review, current } = this.props.exercise;
    const { showCategoryText, showExerciseExtraOptions } = this.state;

    const inactive = review && review.value === 2;

    return (
      <tr className={classnames({ inactive })}>
        <td className="category-td">
          <div
            className="exercise-category"
            onMouseEnter={() => this.setState({ showCategoryText: true })}
            onMouseLeave={() => this.setState({ showCategoryText: false })}
            style={{ color: category.label_color }}
          >
            {showCategoryText ? category.title : category.label}
          </div>
        </td>
        <td
          className="download-exercise"
          onMouseEnter={() => this.setState({ showExerciseExtraOptions: true })}
          onMouseLeave={() => this.setState({ showExerciseExtraOptions: false })}
        >
          <Button onClick={this.openPDF}>
            {showExerciseExtraOptions && <Glyphicon glyph="download-alt" />}
            <span className="download-text">{title}</span>
          </Button>

          {current && <span className="exercise-current">current</span>}

          {inactive && <span className="exercise-current exercise-inactive">inactive</span>}

          {!current &&
            !inactive &&
            (showExerciseExtraOptions && (
              <span onClick={this.handleClick} className="exercise-current exercise-inactive exercise-make">
                make current
              </span>
            ))}
        </td>
        <td className="empty-exercise" />

        <td className="button-exercise">
          <Button
            bsStyle={review && review.value === 1 ? 'success' : null}
            onClick={() => this.props.handleValueChange(number, 1)}
          >
            Yes
          </Button>
        </td>
        <td className="button-exercise">
          <Button
            bsStyle={review && review.value === 2 ? 'danger' : null}
            onClick={() => this.props.handleValueChange(number, 2)}
          >
            No
          </Button>
        </td>
        <td className="button-exercise">
          <Button
            bsStyle={review && review.value === 3 ? 'warning' : null}
            onClick={() => this.props.handleValueChange(number, 3)}
          >
            Undecided
          </Button>
        </td>
      </tr>
    );
  }
}
export default Exercise;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Exercises/Exercise.js